import { fontText, StylesIndexInjections } from 'common-react';
import { createStyles, makeUiStyles, Theme } from '../styles/styles';

export default makeUiStyles((theme: Theme) => createStyles({
  stepsWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'center',
      gap: 24,
    },
  },
  stepWrapper: {
    alignItems: 'center',
    display: 'flex',
    flexBasis: 'calc(50% - 34px)',
    flexDirection: 'column',
    borderRadius: 8,
    textAlign: 'center',
    padding: '48px 24px 32px 24px',
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      flexBasis: '100%',
      padding: 24,
    },
  },
  stepDescription: {
    font: fontText('normal', theme.fontSize.l, 28),
    marginTop: 32,
    [theme.breakpoints.down('sm')]: {
      marginTop: 24,
    },
  },
  stepDelimiter: {
    color: theme.color.violets[50],
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      transform: 'rotate(90deg)',
    },
  }
}), { name: 'StepBox', index: StylesIndexInjections.UI_ATOMS });
